var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-product-settings-view" }, [
    _c("div", { staticClass: "editor-product-settings-view-title" }, [
      _vm._v(_vm._s(_vm.$t("views.editorProductSettings.title"))),
    ]),
    _c(
      "div",
      { staticClass: "editor-product-settings-view-body" },
      _vm._l(_vm.internalSettings, function (_, setting) {
        return _c(
          "div",
          { staticClass: "editor-product-settings-view-option" },
          [
            _c("divider", { staticClass: "divider horizontal full" }),
            _c(
              "IconComponent",
              { staticClass: "editor-product-settings-view-option-icon" },
              [_vm._v(_vm._s(_vm.productSettingIcon(setting)))]
            ),
            _c(
              "span",
              {
                staticClass: "editor-product-settings-view-option-description",
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("views.editorProductSettings.options." + setting)
                  )
                ),
              ]
            ),
            _c(
              "IconComponent",
              {
                staticClass: "editor-product-settings-view-option-info-icon",
                on: {
                  click: function ($event) {
                    return _vm.onProductSettingInfoClick(setting)
                  },
                },
              },
              [_vm._v("alert_info")]
            ),
            _c("SwitchBoxComponent", {
              attrs: { value: _vm.isProductSettingChecked(setting) },
              on: {
                change: function ($event) {
                  return _vm.onProductSettingChange(setting, $event)
                },
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }